import {
    options_retentionPolicies_policyDescriptionWithDurationText,
    options_retentionPolicies_policyDescriptionWithoutDurationText,
    options_retentionPolicies_defaultRetentionTagDescriptionText,
    options_retentionPolicies_retentionTypeRequiredDescriptionText,
    options_retentionPolicies_actionNeverMoveText,
    options_retentionPolicies_actionNeverDeleteText,
    options_retentionPolicies_actionMoveToDeletedItemsText,
    options_retentionPolicies_actionMoveToFolderText,
    options_retentionPolicies_actionDeleteAndAllowRecoveryText,
    options_retentionPolicies_actionPermanentlyDeleteText,
    options_retentionPolicies_actionMarkAsPastRetentionLimitText,
    options_retentionPolicies_actionMoveToArchiveText,
} from './extractRetentionPolicyInfo.locstring.json';
import loc, { format } from 'owa-localize';
import {
    ActiveRetentionPolicyRowType,
    AvailableRetentionPolicyRowType,
} from '../store/schema/RetentionPolicyRowType';
import RetentionPolicyTagDisplay from 'owa-service/lib/contract/RetentionPolicyTagDisplay';
import RetentionActionType from 'owa-service/lib/contract/RetentionActionType';

import ElcFolderType from 'owa-service/lib/contract/ElcFolderType';
import { getRetentionDuration } from 'owa-retention-policies-common';

/**
 * Obtain the needed data needed for component from the retention policy tag display info
 * @param tag the retention policy tag info for display
 */
export default function extractRetentionPolicyInfo(
    tag: RetentionPolicyTagDisplay
): ActiveRetentionPolicyRowType | AvailableRetentionPolicyRowType {
    const retentionActionDescription = getRetentionActionDescription(tag);
    const retentionDuration = getRetentionDuration(tag);
    const typeDescription = getTypeDescription(tag);
    const description = retentionDuration
        ? format(
              loc(options_retentionPolicies_policyDescriptionWithDurationText),
              retentionActionDescription,
              retentionDuration,
              typeDescription
          )
        : format(
              loc(options_retentionPolicies_policyDescriptionWithoutDurationText),
              retentionActionDescription,
              typeDescription
          );
    return {
        isChecked: false,
        description: description,
        ...tag,
    };
}

export function getTypeDescription({
    OptionalTag: optionalTag,
    Type: type,
}: RetentionPolicyTagDisplay): string {
    return optionalTag
        ? ''
        : type == ElcFolderType.All
        ? loc(options_retentionPolicies_defaultRetentionTagDescriptionText)
        : loc(options_retentionPolicies_retentionTypeRequiredDescriptionText);
}

export function getRetentionActionDescription({
    RetentionEnabled: retentionEnabled,
    RetentionAction: retentionAction,
}: RetentionPolicyTagDisplay): string {
    if (!retentionEnabled) {
        return retentionAction == RetentionActionType.MoveToArchive
            ? loc(options_retentionPolicies_actionNeverMoveText)
            : loc(options_retentionPolicies_actionNeverDeleteText);
    }

    switch (retentionAction) {
        case RetentionActionType.MoveToDeletedItems:
            return loc(options_retentionPolicies_actionMoveToDeletedItemsText);
        case RetentionActionType.MoveToFolder:
            return loc(options_retentionPolicies_actionMoveToFolderText);
        case RetentionActionType.DeleteAndAllowRecovery:
            return loc(options_retentionPolicies_actionDeleteAndAllowRecoveryText);
        case RetentionActionType.PermanentlyDelete:
            return loc(options_retentionPolicies_actionPermanentlyDeleteText);
        case RetentionActionType.MarkAsPastRetentionLimit:
            return loc(options_retentionPolicies_actionMarkAsPastRetentionLimitText);
        case RetentionActionType.MoveToArchive:
            return loc(options_retentionPolicies_actionMoveToArchiveText);
        default:
            return '';
    }
}
